const defaultEmptyOption = {value: "", label: "-"}

function setEmptyToSelectsOptions(select, emptyMessage = null){
    let newEmpty = {
        ...defaultEmptyOption
    };
    newEmpty.label = emptyMessage?? newEmpty.label;
    newEmpty.label = newEmpty.label.toUpperCase();

    if(!select.find(e => e.value == "")){
        select.unshift(newEmpty);
    }

    return select;
  }

const recebimentoDefaultOptions = [
    { value: "", label: "Sem forma de recebimento" },
    { value: "email", label: "E-mail" },
    { value: "hibrido", label: "Hibrido" },
    { value: "impresso", label: "Impresso" },
];

const classificacaoFiscalDefaultOptions = [
    { value: "", label: "Sem classificação" },
    { value: "revenda", label: "Revenda" },
    { value: "industria", label: "Consumo Indústria" },
    { value: "proprio", label: "Consumo Próprio" },
];

const tipoPessoaDefaultOptions = [
    { value: 1, label: "CPF - Pessoa Física" },
    { value: 2, label: "CNPJ - Pessoa Jurídica" }      
]

const defaultEmptyMessages = {
    trilha: "Sem trilha",
    grupoSegmento: "Sem grupo de segmento",
    segmento: "Sem segmento",
    grupoCentralizador: "Sem grupo centralizador"
}

export {
    recebimentoDefaultOptions,
    classificacaoFiscalDefaultOptions,
    defaultEmptyOption,
    setEmptyToSelectsOptions,
    defaultEmptyMessages,
    tipoPessoaDefaultOptions
}